/**
 * IoT 模块常量定义
 * 
 * @generated 2025-12-06
 */

import {
  DeviceOnlineStatus,
  DeviceStatus,
  DeviceStatusCode,
  DeviceType,
  Protocol,
  AlarmLevel,
  AlarmStatus,
  VendorStatus
} from './enums'

/** 设备在线状态选项 */
export const DEVICE_ONLINE_STATUS_OPTIONS = [
  { value: DeviceOnlineStatus.OFFLINE, label: '离线', color: 'gray' },
  { value: DeviceOnlineStatus.ONLINE, label: '在线', color: 'green' }
] as const

/** 设备运行状态选项 */
export const DEVICE_STATUS_OPTIONS = [
  { value: DeviceStatus.OFFLINE, label: '离线', color: 'gray' },
  { value: DeviceStatus.IDLE, label: '空闲', color: 'blue' },
  { value: DeviceStatus.RUNNING, label: '运行中', color: 'green' },
  { value: DeviceStatus.ALARM, label: '报警', color: 'red' }
] as const

/** 设备运行状态码映射 */
export const DEVICE_STATUS_CODE_MAP: Record<DeviceStatusCode, string> = {
  [DeviceStatusCode.OFFLINE]: '离线',
  [DeviceStatusCode.IDLE]: '空闲',
  [DeviceStatusCode.RUNNING]: '运行中',
  [DeviceStatusCode.ALARM]: '报警'
}

/** 设备类型选项 */
export const DEVICE_TYPE_OPTIONS = [
  { value: DeviceType.CNC, label: '数控机床', icon: 'Factory' },
  { value: DeviceType.PLC, label: 'PLC', icon: 'Cpu' },
  { value: DeviceType.SENSOR, label: '传感器', icon: 'Radio' },
  { value: DeviceType.ROBOT, label: '机器人', icon: 'Bot' }
] as const

/** 协议类型选项 */
export const PROTOCOL_OPTIONS = [
  { value: Protocol.NCLINK, label: 'NC-Link', description: '华中数控' },
  { value: Protocol.OPCUA, label: 'OPC-UA', description: '西门子/发那科' },
  { value: Protocol.MODBUS, label: 'Modbus', description: '通用工控' },
  { value: Protocol.MTCONNECT, label: 'MTConnect', description: '机床数据采集标准' }
] as const

/** 报警级别选项 */
export const ALARM_LEVEL_OPTIONS = [
  { value: AlarmLevel.INFO, label: '提示', color: 'blue' },
  { value: AlarmLevel.WARNING, label: '警告', color: 'yellow' },
  { value: AlarmLevel.ERROR, label: '错误', color: 'orange' },
  { value: AlarmLevel.CRITICAL, label: '严重', color: 'red' }
] as const

/** 报警级别映射 */
export const ALARM_LEVEL_MAP: Record<AlarmLevel, string> = {
  [AlarmLevel.INFO]: '提示',
  [AlarmLevel.WARNING]: '警告',
  [AlarmLevel.ERROR]: '错误',
  [AlarmLevel.CRITICAL]: '严重'
}

/** 报警状态选项 */
export const ALARM_STATUS_OPTIONS = [
  { value: AlarmStatus.ACTIVE, label: '活动', color: 'red' },
  { value: AlarmStatus.ACKNOWLEDGED, label: '已确认', color: 'yellow' },
  { value: AlarmStatus.CLEARED, label: '已清除', color: 'green' }
] as const

/** 报警状态映射 */
export const ALARM_STATUS_MAP: Record<AlarmStatus, string> = {
  [AlarmStatus.ACTIVE]: '活动',
  [AlarmStatus.ACKNOWLEDGED]: '已确认',
  [AlarmStatus.CLEARED]: '已清除'
}

/** 厂家状态选项 */
export const VENDOR_STATUS_OPTIONS = [
  { value: VendorStatus.DISABLED, label: '禁用', color: 'gray' },
  { value: VendorStatus.ENABLED, label: '启用', color: 'green' }
] as const

/** 默认采集间隔（毫秒） */
export const DEFAULT_POLL_INTERVAL = 5000

/** 最小采集间隔（毫秒） */
export const MIN_POLL_INTERVAL = 1000

/** 最大采集间隔（毫秒） */
export const MAX_POLL_INTERVAL = 60000
